rdefine('app/stores/hoursSpecialModal',['backbone','text!stores/hoursModalSpecial.html','text!stores/hoursRowSpecial.html','text!stores/hoursSpecialModal.html'],function(Backbone,template,rowTemplate,baseTemplate) {

    var variants = [];
    for(var i =0;i<24;i++) {
        variants.push({label:i.toString().padStart(2,'0')+":00"});
        variants.push({label:i.toString().padStart(2,'0')+":30"});
    }

    var VariantView = Backbone.Ribs.View.extend({
        className:'variant',
        bindings:{
            el: {
                text: {
                    data: 'model.label'
                }
            }
        },
        events:{
            "click":"choiceMe"
        },
        choiceMe:function() {
            this.collection.trigger('choice',this.model.get("label"));
        }
    });

    var TimeSetup = Backbone.Ribs.View.extend({
        bindings:{
            '.first_time .variant-list':{
                collection:{
                    col:'variants',
                    view:VariantView
                }
            },
            '.second_time .variant-list':{
                collection:{
                    col:'variants',
                    view:VariantView
                }
            },
            '.first_time .variants-popup':{
                classes:{
                    opened:{
                        data:'cmodel.openfirst'
                    }
                }
            },
            '.second_time .variants-popup':{
                classes:{
                    opened:{
                        data:'cmodel.opensecond'
                    }
                }
            },
            '.btn-primary':{
                toggle:'cmodel.canaddnext'
            },
            '.btn-default':{
                toggle:'cmodel.candelete'
            },
            '.first_time input':{
                value:{data:'cmodel.ftime',events:'change keyup'}
            },
            '.second_time input':{
                value:{data:'cmodel.stime',events:'change keyup'}
            }
        },
        events:{
            "keyup .first_time input":"onFirstUp",
            "keydown .first_time input":"onFirstDown",
            "keyup .second_time input":"onSecondUp",
            "keydown .second_time input":"onSecondDown",
            "focus .first_time input":"onFirstFocus",
            "focus .second_time input":"onSecondFocus",
            "blur .first_time input":"onFirstBlur",
            "blur .second_time input":"onSecondBlur",
            "click .first_time .variant24":"firstChoice24",
            "click .second_time .variant24":"firstChoice24",
            "click .btn-primary":"addNextRow",
            "click .btn-default":"removeCurrentRow"
        },
        opened:'none',
        initialize:function(options) {
            this.variantsBase = new Backbone.Ribs.Collection(variants,{model:Backbone.Ribs.Model});
            this.variants = new Backbone.Ribs.Collection([],{model:Backbone.Ribs.Model});
            this.variants.on('choice', function(label){
                switch (this.opened) {
                    case "first":
                        this.cmodel.set("ftime",label);
                        break;
                    case "second":
                        this.cmodel.set("stime",label);
                        break;
                }
            }.bind(this));
            this.filterBy("");
            var ftime = this.model.get('ftime');
            var stime = this.model.get('stime');
            this.cmodel = new Backbone.Ribs.Model({openfirst:false,opensecond:false,canaddnext:false,ftime:ftime?ftime:'',stime:stime ? stime : '',candelete:false});
            this.cmodel.on('change',this.checkCanAddNext.bind(this));
            this.cmodel.on("change:ftime",this.packCollection.bind(this));
            this.cmodel.on("change:stime",this.packCollection.bind(this));
            this.$el.html(Template7.compile(rowTemplate)());
            this.collection.on("reset add remove", function () {
                setTimeout(function(){
                    this.checkCanAddNext();
                    this.checkCanDelete();
                }.bind(this),0);
            }.bind(this));
            this.checkCanAddNext();
            this.checkCanDelete();
        },
        onFirstUp:function(e) {
            this.filterBy(this.$el.find(".first_time input").val());
            this.checkCanAddNext();
        },
        onFirstDown:function(e) {
            var kk = e.keyCode;
            console.log(this.cmodel.get("ftime"));
            if(this.cmodel.get("ftime").length>4 && kk!==8) {
                e.preventDefault();
                return false;
            }
            if(this.cmodel.get("ftime").length==2 && kk!==186 && kk!==8) {
                this.$el.find(".first_time input").val(this.cmodel.get("ftime")+":");
                this.cmodel.set(this.cmodel.get("ftime")+":");
            }
            switch (this.$el.find(".first_time input").val().length) {
                case 0:
                    if(!(/^(48|49|50)$/.test(kk))) {
                        this.$el.find(".first_time input").val(this.cmodel.get("ftime"));
                        e.preventDefault();
                        return false;
                    }
                    break;
                case 1:
                    if(this.$el.find(".first_time input").val().substr(0,1)==="2") {
                        if(!(/^(8|48|49|50|51)$/.test(kk))) {
                            this.$el.find(".first_time input").val(this.cmodel.get("ftime"));
                            e.preventDefault();
                            return false;
                        }
                    }else{
                        if(!(/^(8|48|49|50|51|52|53|54|55|56|57|8)$/.test(kk))) {
                            this.$el.find(".first_time input").val(this.cmodel.get("ftime"));
                            e.preventDefault();
                            return false;
                        }
                    }
                    break;
                case 2:
                    if(!(/^(48|49|50|51|52|53|186|8)$/.test(kk))) {
                        this.$el.find(".first_time input").val(this.cmodel.get("ftime"));
                        e.preventDefault();
                        return false;
                    }
                    break;
                case 3:
                    if(!(/^(48|49|50|51|52|53|8)$/.test(kk))) {
                        this.$el.find(".first_time input").val(this.cmodel.get("ftime"));
                        e.preventDefault();
                        return false;
                    }
                    break;
                case 4:
                    if((/^(48|49|50|51|52|53|54|55|56|57|186)$/.test(kk))) {
                        setTimeout(function(){
                            this.$el.find(".second_time input").focus();
                        }.bind(this),100);
                    }
                    break;
            }
            if(!(/^(8|48|49|50|51|52|53|54|55|56|57|186)$/.test(kk))) {
                this.$el.find(".first_time input").val(this.cmodel.get("ftime"));
                e.preventDefault();
                return false;
            }
        },
        onSecondUp:function(e) {
            this.filterBy(this.$el.find(".second_time input").val());
            this.checkCanAddNext();
        },
        onSecondDown:function(e) {
            var kk = e.keyCode;

            if(this.cmodel.get("stime").length>4 && kk!==8) {
                e.preventDefault();
                return false;
            }
            if(this.cmodel.get("stime").length==2 && kk!==186 && kk!==8) {
                this.$el.find(".second_time input").val(this.cmodel.get("stime")+":");
                this.cmodel.set(this.cmodel.get("stime")+":");
            }
            switch (this.$el.find(".second_time input").val().length) {
                case 0:
                    if(!(/^(48|49|50)$/.test(kk))) {
                        this.$el.find(".second_time input").val(this.cmodel.get("stime"));
                        e.preventDefault();
                        return false;
                    }
                    break;
                case 1:
                    if(this.$el.find(".first_time input").val().substr(0,1)==="2") {
                        if(!(/^(8|48|49|50|51)$/.test(kk))) {
                            this.$el.find(".second_time input").val(this.cmodel.get("stime"));
                            e.preventDefault();
                            return false;
                        }
                    }else{
                        if(!(/^(8|48|49|50|51|52|53|54|55|56|57|8)$/.test(kk))) {
                            this.$el.find(".second_time input").val(this.cmodel.get("stime"));
                            e.preventDefault();
                            return false;
                        }
                    }
                    break;
                case 2:
                    if(!(/^(48|49|50|51|52|53|186|8)$/.test(kk))) {
                        this.$el.find(".second_time input").val(this.cmodel.get("stime"));
                        e.preventDefault();
                        return false;
                    }
                    break;
                case 3:
                    if(!(/^(48|49|50|51|52|53|8)$/.test(kk))) {
                        this.$el.find(".second_time input").val(this.cmodel.get("stime"));
                        e.preventDefault();
                        return false;
                    }
                    break;
                case 4:
                    break;
            }
            if(!(/^(8|48|49|50|51|52|53|54|55|56|57|186)$/.test(kk))) {
                this.$el.find(".second_time input").val(this.cmodel.get("stime"));
                e.preventDefault();
                return false;
            }
        },
        onFirstFocus: function (e) {
            setTimeout(function(){
                this.opened = "first";
                this.filterBy(this.$el.find(".first_time input").val());
                this.cmodel.set({openfirst:true,opensecond:false});
            }.bind(this),0);
        } ,
        onSecondFocus: function (e) {
            setTimeout(function(){

                this.opened = "second";
                this.filterBy(this.$el.find(".second_time input").val());
                this.cmodel.set({openfirst:false,opensecond:true});
            }.bind(this),0);
        },
        onFirstBlur: function (e) {
            setTimeout(function(){
                this.cmodel.set({openfirst:false,opensecond:false});
                this.checkCanAddNext();
            }.bind(this),0);
        },
        onSecondBlur: function (e) {
            setTimeout(function(){
                this.cmodel.set({openfirst:false,opensecond:false});
                this.checkCanAddNext();
            }.bind(this),0);
        },
        checkCanAddNext:function(){

        },
        checkCanDelete:function(){
            this.cmodel.set('candelete',this.collection.length > 1);
        },
        firstChoice24:function() {
            this.cmodel.set({ftime:"00:00",stime:"00:00"});
        },
        secondChoice24:function() {
            this.cmodel.set({ftime:"00:00",stime:"00:00"});
        },
        filterBy:function(ss) {
            this.variants.reset(this.variantsBase.filter(function(el){
                if(ss.length === 0) { return true; }
                ss = ss.substr(0,2);
                return el.get("label").indexOf(ss)===0;
            }));
        },
        addNextRow:function() {
            this.collection.trigger('addnextrow');
        },
        removeCurrentRow:function() {
            this.undelegateEvents();
            this.collection.remove(this.model);
        },
        packCollection:function() {
            this.model.set({ftime:this.cmodel.get("ftime"),stime:this.cmodel.get("stime")});
            this.collection.trigger('pack');
        }
    });

    var WeekdaySetup = Backbone.Ribs.View.extend({
        tagName:'div',
        className:'weekday-setup',
        times:null,
        events:{
            "click .add-row-modal-extend":"addNextRow",
            "click .remove-time-row":"removeTimeRow"
        },
        initialize:function (options) {
            this.model = options.model;
            this.preventBindings();
            this.key = options.key;
            var tms = this.model.get("times");
            this.times = new Backbone.Ribs.Collection(tms,{model:Backbone.Ribs.Model});
            if(!this.times.length) {
                this.times.add({});
            }
            this.bindings = {
                'input[type=checkbox]':{
                    checked:'model.enabled'
                },
                '.on-opened':{
                    toggle:'model.enabled'
                },
                '.date-place':{
                  value:'model.date'
                },
                '.on-closed':{
                    toggle:{data:'model.enabled',processor:function(a) {return !a;}}
                },
                '.list-of-times':{
                    collection:{
                        col:'times',
                        view:TimeSetup
                    },
                    toggle:'model.enabled'
                },
                '.add-row-modal-extend':{
                    toggle:'model.enabled'
                }
            };
            this.$el.html(Template7.compile(template)({keyName:"stores.hours."+this.model.cid}));
            this.addBindings(this.bindings);
            this.times.on("addnextrow",this.addNextRow.bind(this));
            this.times.on('add remove pack',this.packToModel.bind(this));
            this.model.on("change:enabled",this.clearTimes.bind(this));//add by ask Willy
            this.model.on("change",this.packToModel.bind(this));
        },
        addNextRow:function() {
            this.times.add({ftime:'',stime:''});
        },
        packToModel:function() {
            var times = [];
            for (var i in this.times.models) {
                times.push(this.times.models[i].attributes);
            }
            this.model.set("times",times);
            console.log("MPACK",this.model.attributes);
            this.model.collection.trigger("packit");
            //this.model.trigger("change");
        },
        clearTimes:function() {
            if(!this.model.get('enabled')) {
                this.times.reset([{ftime:'',stime:''}]);
                this.model.set("times", []);
            }
        },
        removeTimeRow:function() {
            this.times.off();
            this.collection.remove(this.model);
        }
    });

    return Backbone.Ribs.View.extend({
        tagName:'div',
        bindings:{
            '.list-of-row':{
                collection:{
                    col:'collection',
                    view:WeekdaySetup
                }
            }
        },
        events:{
            "click .add-row-modal":"addRow"
        },
        initialize:function(options) {
            this.$el.html(Template7.compile(baseTemplate)());
            this.collection = options.modalOpts.config.collection;
        },
        addRow:function () {
            this.collection.add({});
        }
    });
});